import React, { Component } from 'react'
import {
    Row,
    Col,
    Input,
    Table,
    Select,
    Button,
    Modal,
    InputNumber,
    Pagination,
    Checkbox,
    Card,
    Dropdown,
    Icon,
    Menu
} from 'antd'
import { app } from '../../app'
import api from '../../api'
import utils from '../../utils'
import ReviewSearch from '../../components/ReviewSearch'
import '../../css/trainSign.css'
import _ from 'underscore'

const { Option } = Select

/**
 * 判断审核
 * @param audit
 * @returns {string}
 */
function checkAudit (audit) {
    switch (audit) {
        case '0':
            return '未审核'
        case '1':
            return '已通过'
        case '2':
            return '不通过'
    }
}

class NTrainSignList extends Component {
    constructor (props) {
        super(props)
        this.state = {
            page: 1,
            total: 0,
            type: '0',
            pay_status: '1',
            search_type: 'searchform_name',
            search_val: '',
            dataList: [],
            selectedRowKeys: [],
            data_loading: false
        }
    }

    async componentDidMount () {
        this._isMounted = true
        this.props.train_id && await this.dataSource(1)
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 报名人员数据
     * @param page
     * @returns {Promise<void>}
     * @constructor
     */
    dataSource = async (page) => {
        const init_state = { data_loading: true, dataList: [], selectedRowKeys: [] }
        if (page) {
            init_state.page = page
        } else {
            page = this.state.page
        }
        await this.setData(init_state)
        const { train_id } = this.props, { search_type, search_val, pay_status, type } = this.state, params = {
            train_id,
            page,
            search_type,
            search_val,
            pay_status,
            type,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.CheckApplyUser, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        if (page === this.state.page) {
            await this.setData({ data_loading: false, dataList: utils.addArrayKey(data), total: parseInt(total || 0) })
        }
    }

    /**
     * 签到/缺席
     * @param id
     * @param singin_status
     * @returns {Promise<void>}
     */
    handleSign = async (id, singin_status) => {
        if (Array.isArray(id)) {
            if (!id.length) {
                app.alert('请选择操作内容', 'warn')
                return
            }
            id = id.map(index => this.state.dataList[index - 1].id).join(',')
        }
        const params = {
            id,
            singin_status,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, msg } = await app.post(api.TrainSingin, params)
        if (flag === 1) {
            app.alert('考勤成功', 'success')
            await this.dataSource()
        } else {
            app.alert(msg, 'error')
        }
    }
    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource(1)
    }

    /**
     * 录入时长/评语
     **/
    handleLPTrain = (id, type, item = {}) => {
        if (Array.isArray(id)) {
            if (!id.length) {
                app.alert('请选择操作内容', 'warn')
                return
            }
            id = id.map(index => this.state.dataList[index - 1].id).join(',')
        }
        let title = '', content = '', text = ''
        if (type === '1') {
            text = item.train_hour ? parseFloat(item.train_hour) : 0
            title = '录入时长'
            content = (
                <div>
                    <InputNumber defaultValue={text || 0} min={0} precision={1} onChange={(value) => {
                        text = value
                    }}/>
                    <span> 时</span>
                </div>
            )
        } else if (type === '2') {
            text = item.train_comment || ''
            title = '培训评语'
            content = (
                <div>
                    <Input.TextArea rows={4} defaultValue={text || ''} onChange={(e) => {
                        text = e.target.value
                    }}/>
                    <div style={{ color: 'red' }}>注：批量录入培训评语时，最新录入的评语会覆盖之前录入的培训评语。</div>
                </div>
            )
        } else if (type === '3') {
            text = item.fraction || ''
            title = '培训成绩'
            content = (
                <div>
                    <Input.TextArea rows={4} defaultValue={text || ''} onChange={(e) => {
                        text = e.target.value
                    }}/>
                    <div style={{ color: 'red' }}>注：批量录入培训成绩时，最新录入的成绩会覆盖之前录入的培训成绩。</div>
                </div>
            )
        } else if (type === '4') {
            text = item.train_grade || undefined
            title = '证书级别'
            content = (
                <div>
                    <Select style={{ width: '100%' }} defaultValue={text} placeholder="选择证书级别" onChange={value => {
                        text = value
                    }}>
                        <Option value="1">学员</Option>
                        <Option value="2">教官</Option>
                    </Select>
                </div>
            )
        } else {
            return false
        }
        let modal = Modal.confirm({
            title,
            content,
            okText: '确定',
            cancelText: '取消',
            destroyOnClose: true,
            style: { top: '35%' },
            zIndex: 1020,
            icon: (<Icon type="info-circle" style={{ color: '#1890ff' }}/>),
            onOk: async () => {
                if (!text) {
                    app.alert('请填写内容', 'warn')
                    return
                }
                let params = {
                    id,
                    type,
                    indexno: app.getData('indexno'),
                    account: app.getData('account'),
                }
                switch (type) {
                    case '1':
                        params.hour = text
                        break
                    case '2':
                        params.comment = text
                        break
                    case '3':
                        params.fraction = text
                        break
                    case '4':
                        params.train_grade = text
                        break
                }
                let { flag, msg } = await app.post(api.TrainHourComment, params)
                if (flag === 1) {
                    app.alert('操作成功', 'success')
                    await this.dataSource()
                    modal.destroy()
                } else {
                    app.alert(msg, 'warn')
                }
            }
        })
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.dataList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 打开审核信息
     * @param item
     */
    handleOpenReview = (item) => {
        Modal.info({
            title: `【${item.vname}】的审核信息`,
            centered: true,
            zIndex: 1020,
            width: '50%',
            content: (
                <div> 
                    <Card bodyStyle={{ padding: 12 }} style={{ marginTop: 10 }}
                          title={<div style={{ textAlign: 'center' }}>队管审核</div>}>
                        {item.team_header_audit === '0' ? (<div style={{ textAlign: 'center' }}>未审核</div>) : (
                            <div>
                                <div>审核人：{item.team_header_indexno}</div>
                                <div>审核状态：{checkAudit(item.team_header_audit)}</div>
                                <div>审核时间：{item.team_header_time || '无'}</div>
                                {item.team_header_audit === '2' ?
                                    <Row type="flex">
                                        <Col style={{ width: 90 }}>不通过原因：</Col>
                                        <Col style={{ width: 'calc(100% - 90px)' }}>{item.detail}</Col>
                                    </Row> : null}
                            </div>
                        )}
                    </Card>
                    {/* <Card bodyStyle={{ padding: 12 }} title={<div style={{ textAlign: 'center' }}>省管审核</div>}
                          style={{ margin: '10px 0' }}>
                        {item.admin_audit === '0' ? (<div style={{ textAlign: 'center' }}>未审核</div>) : (
                            <div>
                                <div>审核人：{item.admin_indexno}</div>
                                <div>审核状态：{checkAudit(item.admin_audit)}</div>
                                <div>审核时间：{item.admin_time || '无'}</div>
                                {item.admin_audit === '2' ?
                                    <Row type="flex">
                                        <Col style={{ width: 90 }}>不通过原因：</Col>
                                        <Col style={{ width: 'calc(100% - 90px)' }}>{item.detail}</Col>
                                    </Row> : null}
                            </div>
                        )}
                    </Card> */}
                    <Card bodyStyle={{ padding: 12 }}
                          title={<div style={{ textAlign: 'center' }}>发布人审核</div>}>
                        {item.publish_audit === '0' ? (<div style={{ textAlign: 'center' }}>未审核</div>) : (
                            <div>
                                <div>审核人：{item.publish_indexno}</div>
                                <div>审核状态：{checkAudit(item.publish_audit)}</div>
                                <div>审核时间：{item.publish_time || '无'}</div>
                                {item.publish_audit === '2' ?
                                    <Row type="flex">
                                        <Col style={{ width: 90 }}>不通过原因：</Col>
                                        <Col style={{ width: 'calc(100% - 90px)' }}>{item.detail}</Col>
                                    </Row> : null}
                            </div>
                        )}
                    </Card>
                </div>
            )
        })
    }

    render () {
        let { data_loading, dataList, page, total, pay_status, selectedRowKeys, type } = this.state,
            { is_class, is_certificate } = this.props,
            columns = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '7%',
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '7%',
                },
                {
                    title: '所属地区',
                    dataIndex: 'province',
                    key: 'province',
                    width: '7%',
                },
                {
                    title: '所属队伍',
                    dataIndex: 'teamname',
                    key: 'teamname',
                    width: '10%',
                },
                {
                    title: '支付情况',
                    dataIndex: 'pay_status',
                    key: 'pay_status',
                    width: '7%',
                    render (status) {
                        switch (status) {
                            case '0':
                                return (<span>未支付</span>)
                            case '1':
                                return (<span>已支付</span>)
                            case '2':
                                return (<span>已退款</span>)
                        }
                    }
                },
                {
                    title: '审核状态',
                    dataIndex: 'apply_status',
                    key: 'apply_status',
                    width: '7%',
                    render: (text, record) => {
                        switch (text) {
                            case '1':
                                return (<span className="review-status"
                                              onClick={() => this.handleOpenReview(record)}>已通过</span>)
                            case '2':
                                return (<span className="review-status"
                                              onClick={() => this.handleOpenReview(record)}>不通过</span>)
                            default:
                                return (<span className="review-status"
                                              onClick={() => this.handleOpenReview(record)}>未审核</span>)
                        }
                    }
                },
                {
                    title: '班级名称',
                    dataIndex: 'class_name',
                    key: 'class_name',
                    width: '10%',
                    render (text) {
                        return (<span>{text || '无'}</span>)
                    }
                },
                {
                    title: '联系电话',
                    dataIndex: 'mobile',
                    key: 'mobile',
                    width: '10%',
                    render (text) {
                        return (<span>{text || '-'}</span>)
                    }
                },
                {
                    title: '签到时间',
                    dataIndex: 'singin_time',
                    key: 'singin_time',
                    width: '12%',
                    render (text) {
                        return (<span>{text || '无记录'}</span>)
                    }
                },
                {
                    title: '培训时长',
                    dataIndex: 'train_hour',
                    key: 'train_hour',
                    width: '7%'
                },
                {
                    title: '考勤',
                    dataIndex: 'id',
                    key: 'id',
                    width: '7%',
                    render: (id, record) => {
                        let { singin, is_select } = record
                        if (is_select === 1) {
                            return (<span>未开班</span>)
                        } else if (singin === '1') {
                            return (<span>已签到</span>)
                        } else if (singin === '2') {
                            return (<span>已缺席</span>)
                        } else {
                            return record.pay_status === '2' ? ' - ' : (
                                <div>
                                    <div>
                                        <Button size="small" type="primary" disabled={selectedRowKeys.length > 1}
                                                onClick={() => this.handleSign(id, '1')}>签到</Button>
                                    </div>
                                    <div style={{ marginTop: 6 }}>
                                        <Button size="small" disabled={selectedRowKeys.length > 1}
                                                onClick={() => this.handleSign(id, '2')}>缺席</Button>
                                    </div>
                                </div>
                            )
                        }
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'cz',
                    width: '9%',
                    render: (id, record) => {
                        return record.pay_status === '2' ? ' - ' : (
                            <div>
                                <div>
                                    <Dropdown disabled={selectedRowKeys.length > 1} overlay={
                                        <Menu onClick={({ key }) => this.handleLPTrain(id, key, record)}>
                                            <Menu.Item key="1">培训时长</Menu.Item>
                                            <Menu.Item key="2">培训评语</Menu.Item>
                                            {is_certificate === '1' ? (
                                                <Menu.Item key="3">培训成绩</Menu.Item>
                                            ) : null}
                                        </Menu>
                                    }>
                                        <Button size="small" disabled={selectedRowKeys.length > 1}>
                                            录入 <Icon type="down"/>
                                        </Button>
                                    </Dropdown>
                                    {/*<Button size="small" disabled={selectedRowKeys.length > 1}*/}
                                    {/*onClick={() => }>录入时长</Button>*/}
                                </div>
                                {is_certificate === '1' ? (
                                    <div style={{ marginTop: 6 }}>
                                        <Button size="small" disabled={selectedRowKeys.length > 1}
                                                onClick={() => this.handleLPTrain(id, '4', record)}>证书级别</Button>
                                    </div>
                                ) : null}
                            </div>
                        )
                    }
                },
            ],
            rowSelection = null
        if (pay_status === '1' && type !== '3') {
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
        }
        return (
            <div>
                <Row type="flex" align="middle" style={{ height: 50 }}>
                    <span>支付状态： </span>
                    <Select value={pay_status} style={{ width: 120 }} onChange={async (value) => {
                        await this.setData({ pay_status: value, type: '0' })
                        await this.dataSource(1)
                    }}>
                        <Option value="1">已支付</Option>
                        <Option value="2">已退款</Option>
                    </Select>
                    <span style={{ marginLeft: 10 }}>审核状态： </span>
                    <Select value={type} style={{ width: 120 }} onChange={async (value) => {
                        await this.setData({ type: value })
                        await this.dataSource(1)
                    }}>
                        <Option value="0">全部</Option>
                        <Option value="1" disabled={pay_status === '2'}>未审核</Option>
                        <Option value="2" disabled={pay_status === '2'}>已通过</Option>
                        <Option value="3" disabled={pay_status === '1'}>不通过</Option>
                    </Select>
                    <ReviewSearch onSearch={this.handleSearch}
                                  type={is_class === '1' ? 'train-sign-class' : 'train-sign'}/>
                </Row>
                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    locale={app.tbLocale(data_loading)}
                    loading={data_loading}
                    dataSource={dataList}
                    scroll={{ y: 'calc(100vh - 254px)' }}
                    pagination={false}
                    footer={() => {
                        return (
                            <Row hidden={dataList.length === 0}>
                                <Col span={10}>
                                    <div hidden={pay_status === '2' || type === '3'}>
                                        <Checkbox
                                            checked={dataList.length !== 0 && dataList.length === selectedRowKeys.length}
                                            onChange={this.handleAllSel}>全选</Checkbox>
                                        <Button size="small" style={{ margin: '0 20px' }} type="primary"
                                                onClick={() => this.handleSign(selectedRowKeys, '1')}>签到</Button>
                                        <Button size="small" onClick={() => this.handleSign(selectedRowKeys, '2')}
                                                type="primary">缺席</Button>
                                        <Button size="small" style={{ margin: '0 20px' }} type="primary"
                                                onClick={() => this.handleLPTrain(selectedRowKeys, '1')}>录入时长</Button>
                                        <Button size="small" onClick={() => this.handleLPTrain(selectedRowKeys, '2')}
                                                type="primary">培训评语</Button>
                                        {
                                            is_certificate === '1' ? [
                                                (<Button key="pl_chengji" size="small" style={{ margin: '0 20px' }}
                                                         type="primary"
                                                         onClick={() => this.handleLPTrain(selectedRowKeys, '3')}>培训成绩</Button>),
                                                (<Button key="pl_jibie" size="small"
                                                         onClick={() => this.handleLPTrain(selectedRowKeys, '4')}
                                                         type="primary">证书级别</Button>),
                                            ] : null
                                        }
                                    </div>
                                </Col>
                                <Col span={14} style={{ textAlign: 'right' }}>
                                    <Pagination total={total} size="small" pageSize={20} current={page}
                                                showTotal={(t) => `共${t}条.`}
                                                onChange={this.dataSource}/>
                                </Col>
                            </Row>
                        )
                    }}
                    size="small"/>
            </div>
        )
    }
}

export default NTrainSignList



// WEBPACK FOOTER //
// ./src/routes/notice/NTrainSignList.jsx